import { c as _c } from "react-compiler-runtime";
import { useEffect, useRef } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { gate } from 'hub-http/gates';
import { useAuth } from '../../auth/context/AuthContext';
export const useFrozenColumnWidthAlert = (columns, frozenOffsets, scrollContainerRef, onFrozenColumnWidthAlert) => {
  const $ = _c(9);
  const widthAlertShownRef = useRef(false);
  const {
    hasGate
  } = useAuth();
  let t0;
  if ($[0] !== hasGate) {
    t0 = hasGate(gate("CRM:Grid:FrozenColumn"));
    $[0] = hasGate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isUngatedForFrozenColumnUpdates = t0;
  let t1;
  let t2;
  if ($[2] !== columns || $[3] !== frozenOffsets || $[4] !== isUngatedForFrozenColumnUpdates || $[5] !== onFrozenColumnWidthAlert || $[6] !== scrollContainerRef) {
    t1 = () => {
      var _scrollContainerRef$c;
      const containerBoundingClient = scrollContainerRef === null || scrollContainerRef === void 0 || (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 ? void 0 : _scrollContainerRef$c.getBoundingClientRect();
      const hasFrozenColumns = containerBoundingClient && columns.length && frozenOffsets.length;
      if (!hasFrozenColumns || !isUngatedForFrozenColumnUpdates) {
        widthAlertShownRef.current = false;
        return;
      }
      const lastFrozenColumnRightOffset = frozenOffsets[frozenOffsets.length - 1] + columns[frozenOffsets.length - 1].width;
      const isFrozenColumnWiderThanTable = containerBoundingClient.width < lastFrozenColumnRightOffset;
      if (isFrozenColumnWiderThanTable && !widthAlertShownRef.current) {
        widthAlertShownRef.current = true;
        FloatingAlertStore.addAlert({
          message: I18n.text("datatable.frozenColumn.widthError"),
          type: "warning",
          timeout: 12000,
          "data-test-id": "frozen-column-width-alert"
        });
        onFrozenColumnWidthAlert === null || onFrozenColumnWidthAlert === void 0 || onFrozenColumnWidthAlert();
      } else {
        if (!isFrozenColumnWiderThanTable && widthAlertShownRef.current) {
          widthAlertShownRef.current = false;
        }
      }
    };
    t2 = [columns, frozenOffsets, scrollContainerRef, isUngatedForFrozenColumnUpdates, onFrozenColumnWidthAlert];
    $[2] = columns;
    $[3] = frozenOffsets;
    $[4] = isUngatedForFrozenColumnUpdates;
    $[5] = onFrozenColumnWidthAlert;
    $[6] = scrollContainerRef;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
};